import { LedgerAccount } from "./ledger.model"
import { Entity } from "./entity.model"

export enum DepreciationMethod {
  LINEAR = "linear",
  DECLINING_BALANCE = "declining_balance",
}

export interface FixedAsset {
  id: string
  name: string
  description?: string
  assetNumber?: string
  entityId: string
  entity?: Entity

  // Financials
  purchaseDate: string
  purchasePrice: number
  salvageValue: number
  usefulLifeMonths: number
  depreciationMethod: DepreciationMethod
  depreciationStartDate?: string

  // Link to source transaction (for automated asset creation)
  transactionId?: string

  // Status
  isActive: boolean
  disposalDate?: string
  disposalProceeds?: number

  // Accounting
  assetAccountId: string
  depreciationAccountId: string
  assetAccount?: LedgerAccount
  depreciationAccount?: LedgerAccount

  // Metadata
  createdAt: string
  updatedAt?: string

  // Computed (from backend)
  currentValue?: number
  accumulatedDepreciation?: number
}

export interface FixedAssetCreate {
  name: string

  description?: string
  assetNumber?: string
  entityId: string
  purchaseDate: string
  purchasePrice: number
  salvageValue?: number
  usefulLifeMonths: number
  depreciationMethod: DepreciationMethod
  isActive?: boolean
  assetAccountId: string
  depreciationAccountId: string
  transactionId?: string // Optional link to source transaction
}

export interface FixedAssetUpdate {
  name?: string
  description?: string
  assetNumber?: string
  purchaseDate?: string
  purchasePrice?: number
  salvageValue?: number
  usefulLifeMonths?: number
  depreciationMethod?: DepreciationMethod
  isActive?: boolean
  disposalDate?: string
  disposalProceeds?: number
  assetAccountId?: string
  depreciationAccountId?: string
}

export interface DepreciationEntry {
  id: string
  assetId: string
  bookingDate: string
  depreciationAmount: number
  accumulatedDepreciation: number
  bookValueAfter: number
  isPosted: boolean
  journalEntryId?: string
}

export interface DepreciationCalculationResult {
  schedule: DepreciationEntry[]
  totalDepreciation: number
  residualValue: number
}
